import React from 'react'
import Hero from '../../Components/Home/Hero/Hero'
import Problem from '../../Components/Home/Problem/Problem'
import Offering from '../../Components/Home/Offering/Offering'
import Occasion from '../../Components/Home/Occasions/Occasion'
import Reviews from '../../Components/Home/Reviews/Reviews'
import CallToAction from '../../Components/Shared/CallToAction/CallToAction'
import Teaser from '../../Components/Home/GetChristmasSorted/Teaser'

function NewHomePage() {
  return (
    <div>
        <Hero />
        <Problem />
        <Teaser />
        <Offering />        
        <Occasion />
        <Reviews />
        <CallToAction paragraph="Browse products or shop by your occasion to find the right gift. Let us personalise, wrap and deliver it for you." />
    </div>
  )
}

export default NewHomePage